

import {Card, Col, Row} from "reactstrap";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {Button, Icon} from "../../../../components/Component";
import {Field} from "../../../../components/fouladyar/field/field";

export function ChangePropStateModal({heading, title, content, submitMode, submitText, cancelText, onClose, onCancel, onSubmit}) {
    const { t, i18n } = useTranslation();

    const [action, setAction] = useState('levelup');

    const style = {
        buttons: {
            padding: "0.5em"
        },
        danaFont: {
            fontFamily: "dana !important",
            margin: "auto"
        },
        divider: {
            height: 1,
            background: "#1a1a1a",
            width: "100%"
        }
    }

    function Divider(){
        return(
            <div style={style.divider}></div>
        )
    }

    function getDescription(){
        switch (action){
            case "reset":
                return <div className="yellow-color">{"حساب فعال کاربر غیر فعال شده و حساب سطح چالش به سطح ابتدایی برمیگردد و کاربر مجدد باید حساب را پاس کند."}</div>
            case "extend":
                return <div className="yellow-color">{"در صورت اکستند حساب تنها ۱۰ روز دیگر به تایم چالش کاربر اضافه خواهد شد"}</div>
            case "suspend":
                return <div className="red-color">{"پس از مسدود کردن حساب کاربر،‌این حساب دیگر قادر به فعال شدن نخواهد بود"}</div>
            case "levelup":
                return ""
            default:
                return ""
        }
    }

    function getButton() {

        switch (action){
            case "reset":
                return(
                    <div className={`btn btn-outline yes-or-no-btn w-100 green-bg-color`} style={{margin: "10px 0px 0px 0px"}}
                            onClick={()=>{
                                onSubmit(action)
                            }}
                    >
                        <div  className="yes-or-no-btn-txt" >ریست حساب</div>
                    </div>
                )
            case "extend":
                return(
                    <Button className={`btn btn-outline yes-or-no-btn w-100 green-bg-color`} style={{margin: "10px 0px 0px 0px"}}
                            onClick={()=>{
                                onSubmit(action)
                            }}
                    >
                        <div  className="yes-or-no-btn-txt" >اکستند حساب</div>
                    </Button>
                )
            case "suspend":
                return(
                    <Button className={`btn btn-outline yes-or-no-btn w-100 red-bg-color`} style={{margin: "10px 0px 0px 0px"}}
                            onClick={()=>{
                                onSubmit(action)
                            }}
                        >
                        <div  className="yes-or-no-btn-txt" >مسدود کردن حساب</div>
                    </Button>
                )
            case "levelup":
                return(
                    <Button className={`btn btn-outline yes-or-no-btn w-100 green-bg-color`} style={{margin: "10px 0px 0px 0px"}}
                            onClick={()=>{
                                onSubmit(action)
                            }}
                    >
                        <div className="yes-or-no-btn-txt" >ارتقا سطح</div>
                    </Button>
                )
            default:
                return ""
        }
    }

    return (
        <div className="yes-or-no">
            <Button onClick={() => onClose(false)}>
                <Icon name="cross"></Icon>
            </Button>
            <h4 style={{padding: "0px 20px"}}>تغیر وضعیت حساب</h4>
            <Divider/>

            <div className="change-state-modal-component" style={{padding: "14px 20px"}}>
                <div className="change-state-modal-description" >لطفا در صورتی که اطلاعات وارد شده کاربر از قبیل نام و نام خانوادگی، کد ملی و تاریخ تولد مطابق اطلاعات درج شده بر روی کارت ملی شخص است، روی دکمه مورد تایید هر یک از موارد بزنید در غیر این صورت روی دکمه نیاز به اصلاح بزنید تا کاربر را به صورت دقیق مطلع کنیم که چه مواردی از احراز هویت مشکل دار است. </div>

                <Field
                    label={"نوع تغییر وضعیت"}
                    className="analytics-select-style"
                    id={"action"}
                    name={"action"}
                    type={'select'}
                    options={[
                        {label: 'ریست حساب', value: 'reset'},
                        {label: 'اکستند حساب', value: 'extend'},
                        {label: 'ارتقا چالش', value: 'levelup'},
                        {label: 'مسدود کردن حساب', value: 'suspend'},
                    ]}
                    value={action}
                    onChange={(e) => {
                        setAction(e)
                    }}
                />

                {getDescription()}


            </div>
            <Divider/>
            <Row className="nk-kycfm-control-list" style={{margin: "10px"}}>
                <Col sm="6" lg="6" xxl="6" xs="12" style={style.buttons}>
                        {getButton()}
                </Col>
                <Col sm="6" lg="6" xxl="6" xs="12" style={style.buttons}>
                    <Button className="btn btn-light yes-or-no-btn btn-outline w-100" style={{margin: "10px 0px 0px 0px"}} onClick={onCancel}>
                        <span className="yes-or-no-btn-txt" >بستن پنجره</span>
                    </Button>
                </Col>
            </Row>

        </div>
    )
}
